import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const SortDownIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 8 14" },
        React.createElement("path", { d: "M4.49994 0H3.49994C3.2238 0 2.99994 0.22386 2.99994 0.5V10H0.543029C0.069689 10 -0.138661 10.5966 0.231769 10.8913L3.68868 13.6411C3.87088 13.786 4.129 13.786 4.3112 13.6411L7.76811 10.8913C8.13855 10.5966 7.93019 10 7.45685 10H4.99994V0.5C4.99994 0.22386 4.77608 0 4.49994 0Z" })));
};

export { SortDownIcon };
//# sourceMappingURL=SortDownIcon.esm.js.map
